<app-block-space layout="spaceship-ledge-height"></app-block-space>

    <div class="container">
        <div class="row" data-aos="zoom-in" data-aos-delay="100">
            <div class="col-md-1"></div>
            <div class="col-md-10">
                <app-block-space layout="spaceship-ledge-height"></app-block-space>
                <app-block-space layout="spaceship-ledge-height"></app-block-space>

                    <div class="document__content card">
                        <div class="typography" *ngIf="datas">
                            <div class="table-responsive-md">
                                <table class="table">
                                    <thead>
                                        <tr>
                                          <th>#</th>
                                          <th>Stram</th>
                                          <!-- <th>Sub Stream</th> -->
                                          <th>Course</th>
                                          <th>University Name</th>
                                          <th>Course Fees</th>
                                          <th>Eligibility</th>
                                          <th>Scholarship</th>
                                          <th>Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let data of datas; let i =index;">
                                          <th>{{ i + 1 }}</th>
                                          <td>{{ data.main_category.name }}</td>
                                          <!-- <td>{{ data.sub_category.name }}</td> -->
                                          <td>{{ data.unique_course.name }}</td>
                                          <td>
                                            <a routerLink="/shop/products/{{ data.universities.slug }}" class="post-header__categories-link">
                                                {{ data.universities.name}}
                                            </a>

                                          </td>
                                          <td>{{ data.course_fees }}</td>
                                          <td>{{ data.eligibility }}</td>
                                          <td>{{ data.scholarship }}</td>
                                          <td>
                                <button (click)="showModal(data)" class="btn btn-primary">Apply Now</button>

                                          </td>


                                        </tr>

                                        </tbody>
                                </table>
                                <p *ngIf="datas?.length === 0" class="text-center">
                                    No Course Available to this filter</p>
                              </div>

                        </div>

                    </div>
            </div>
            <div class="col-md-1"></div>

        </div>

    </div>

<app-block-space layout="before-footer"></app-block-space>
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          ...
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button>
        </div>
      </div>
    </div>
  </div>
